import React, { useRef } from 'react';
import addToMailchimp from "gatsby-plugin-mailchimp"
export class MailChimpSignup extends React.Component {
    state = {
        subscribed: false,
        email: '',
    };

    messageText = "Thank you for subscribing to our Newsletter!";

    handleEmailChange = (e) => {
        this.setState({ email: e.target.value });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.state.subscribed = false;
        const obj = {
            email: this.state.email,
            source: "Newsletter:Blog"
        }
        const url = "https://auth.evitat.com.au/api/v1/news-letter/subscribe"
        return fetch(url, {
            method: 'POST',
            body: JSON.stringify(obj),
            headers: {
                'Content-Type': 'application/json',
                'Accept': "application/json",
            }
        }).then(result => result.json()).then(result => {
            this.setState({ email: '', subscribed: true });
        }).catch((err) => {
            console.log('err', err)
        });
    }
    render () {

        return <div className="mailchimp-signup">
            {!this.state.subscribed ?
                <form onSubmit={this.handleSubmit}>
            <div className="mailchimp-signup--input">
                        <input type="email" autoComplete="off" placeholder="Email address" name="email" value={this.state.email} onChange={this.handleEmailChange} required />
            </div>
                    <button type='submit' className="mailchimp-signup--button">Sign up</button>
        </form> 
        : <h3 dangerouslySetInnerHTML={{ __html: this.messageText }}/>}
        </div>
    }
}